import { render } from "./Bg.vue?vue&type=template&id=5fb92a1a"
import script from "./Bg.vue?vue&type=script&lang=js"
export * from "./Bg.vue?vue&type=script&lang=js"
script.render = render

export default script